import { render, staticRenderFns } from "./RequirementQualityTypeEdit.vue?vue&type=template&id=bbc9f8cc"
import script from "./RequirementQualityTypeEdit.vue?vue&type=script&lang=js"
export * from "./RequirementQualityTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports